import { useRef, useState  } from "react";
import emailjs from "@emailjs/browser";

export default function ContactMe() {
  const form = useRef();
  const [popupMessage, setPopupMessage] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_dvot0dk", "template_mjhqnlt", form.current, {
        publicKey: "Pt8-GplXnMksTIQjc",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          setPopupMessage("Email sent successfully!");
          form.current.reset(); // Clear the form fields
          setTimeout(() => {
            setPopupMessage(""); // Hide the popup message after 3 seconds
          }, 3000);
        },
        (error) => {
          console.log("FAILED...", error.text);
          setPopupMessage("Failed to send email. Please try again.");
          setTimeout(() => {
            setPopupMessage(""); // Hide the popup message after 3 seconds
          }, 3000);
        }
      );
  };
  return (
    <section id="Contact" className="contact--section">
      <div>
        <h2 className="contact-sub--title">Contact Me</h2>
        <p className="contact--section-description">
        I'd love to hear from you. Feel free to introduce yourself or ask any questions you might have.
        </p>
      </div>
      {popupMessage && <div className="popup-message">{popupMessage}</div>}
      <form
        ref={form}
        className="contact--form--container"
        onSubmit={sendEmail}
      >
        <div className="container">
          <label htmlFor="first-name" className="contact--label">
            <span className="text-md">Your Name</span>
            <input
              type="text"
              name="user_name"
              className="contact--input text-md"
              id="first-name"
              required
            />
          </label>
          <label htmlFor="email" className="contact--label">
            <span className="text-md">Email</span>
            <input
              type="email"
              name="user_email"
              className="contact--input text-md"
              id="email"
              required
            />
          </label>
        </div>
        <label htmlFor="message" className="contact--label">
          <span className="text-md">Message</span>
          <textarea
            name="message"
            className="contact--input text-md"
            id="message"
            rows="8"
            placeholder="Type your message..."
          />
        </label>
        <input
          type="submit"
          className="btn btn-primary contact--form--btn"
          value="Send"
        />
      </form>
    </section>
  );
}
